<!-- Header Section Start -->
<div class="header-section header-dashboard-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col header-wrapper">

        <!-- LOGO -->
        <a id="header-logo" [routerLink]="setLogoRouterLink()">
          <img id="header-logo-standard" class="logo-standard" src="assets/images/logo/cedlab-logo.png" alt="CedLab">
          <img class="logo-small" src="assets/images/logo/cedlab-logo-small.png" alt="CedLab">
        </a>

        <!-- SIDE MENU BUTTON-->
        <div id="header-menu-toggle">
          <button (click)="toggleSideMenuEventEmit()" class="side-header-toggle header-icon">
            <i class="fa fa-bars"></i>
          </button>
        </div>

        <!-- SEARCH INPUT -->
        <div id="header-search">
          <app-search></app-search>
        </div>

        <div id="header-right-menu">
          <div id="header-notifications">
            <div class="header-notification-area">

              <!-- WATCHLIST / PORTFOLIO SECTION BTNS -->
              <div id="wp-buttons" class="container-fluid">
                <div>
                  <button id="btn-watchlist" [routerLink]="['/menu/watchlists']">
                    <span>W</span>
                  </button>
                </div>
                <div>
                  <button id="btn-portfolio" [routerLink]="['/menu/portafogli']">
                    <span>P</span>
                  </button>
                </div>
              </div>


              <!-- NOTIFICATIONS ICON -->
              <app-notifications
                (showNotificationsMenuEvent)="showMenuNotifications()"
                [menuNotificationsStatus]="menuNotificationsStatus"
                [isLogged]="userIsLogged">
              </app-notifications>


              <!-- AVATAR -->
              <div [ngClass]="menuUserStatus ? 'adomx-dropdown col-auto show' : 'adomx-dropdown col-auto'">
                <div id="user-avatar" class="rounded-circle">
                  <a (click)="showMenuUser()">{{avatarShortName}}</a>
                </div>

                <div [ngClass]="menuUserStatus ? 'adomx-dropdown-menu dropdown-menu-user show' : 'adomx-dropdown-menu dropdown-menu-user' ">
                  <div class="head">
                    <h5 class="m-0">{{username}}</h5>
                  </div>
                  <div class="body">
                    <ul>
                      <li>
                        <a routerLink="/menu/profilo" (click)="menuUserStatus = false">
                          <i class="fa fa-user"></i>Profilo
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/menu/acquista-servizi', {rinnovo: true}]" (click)="menuUserStatus = false">
                          <i class="fa fa-credit-card"></i>Pagamenti
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <a (click)="download(1)">Termini e Condizioni</a>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <a (click)="signOutEventEmit()">
                          <i class="fa fa-unlock"></i>Sign out
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


